import React from 'react';
import {connect} from "react-redux";
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import {fetchStoreReports} from './reducer';

import {fetchOverdueReleasedReplenishments} from '../services/ReplenishmentModule';
import {showAllOverdueSince} from '../replenishment/reducer';

import OverdueReplenishments from './Widgets/OverdueReplenishments';
import {buildDashboardCsvDownloadUrl} from "../services/AreaControlModule";

export class DashboardManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentDidMount() {
        this.props.fetchStoreReports();
    }

    downloadCsv(storeGln, moduleName) {
        buildDashboardCsvDownloadUrl(storeGln, moduleName).then((url) => {
            window.location = url;
        });
    }

    render() {

        const storeReports = this.props.storeReports.map(storeReport => {
            storeReport.tableId = storeReport.storeGln + '-' + storeReport.moduleName;
            return storeReport;
        });

        const unsyncedFormatter = (cell, row) => {
            if (cell === 0) {
                return cell;
            } else {
                return <span style={{color: 'red'}}>{cell}</span>
            }
        };

        const csvButtonFormatter = (cell) => {
            const storeGln = cell.split('-')[0];
            const moduleName = cell.split('-')[1];
            return <button className="btn btn-primary" onClick={() => {this.downloadCsv(storeGln, moduleName)}}><i className="fa fa-download"/></button>
        };

        return (
            <div className="animated fadeIn" style={{fontSize: 'small'}}>
                <div className="row">
                    <div className="col">
                        <h4 className="card-title">Dashboard</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3">
                        <OverdueReplenishments fetchData={fetchOverdueReleasedReplenishments} showDetails={() => this.props.showAllOverdueSince(5)}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="card">
                            <div className="card-header">Flächenstatus</div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <BootstrapTable data={storeReports} pagination={true} striped hover>
                                                <TableHeaderColumn isKey dataField='tableId' hidden>Table
                                                    ID</TableHeaderColumn>
                                                <TableHeaderColumn dataField='storeGln' dataSort={true} filter={{
                                                    type: 'TextFilter',
                                                    delay: 1000
                                                }}>Store</TableHeaderColumn>
                                                <TableHeaderColumn dataField='retailerName' dataSort={true} filter={{
                                                    type: 'TextFilter',
                                                    delay: 1000
                                                }}>Händler</TableHeaderColumn>
                                                <TableHeaderColumn dataField='city' dataSort={true} filter={{
                                                    type: 'TextFilter',
                                                    delay: 1000
                                                }}>Standort</TableHeaderColumn>
                                                <TableHeaderColumn dataField='moduleName' dataSort={true} filter={{
                                                    type: 'TextFilter',
                                                    delay: 1000
                                                }}>Modul</TableHeaderColumn>
                                                <TableHeaderColumn dataField='noOfGtinWithStock'
                                                                   tdStyle={{fontWeight: 'bold', fontSize: 'large'}}
                                                                   dataSort={true}># Artikel mit
                                                    Bestand</TableHeaderColumn>
                                                <TableHeaderColumn dataField='noOfGtinOutOfStock'
                                                                   tdStyle={{fontWeight: 'bold', fontSize: 'large'}}
                                                                   dataSort={true}># Artikel ohne
                                                    Bestand</TableHeaderColumn>
                                                <TableHeaderColumn dataField='noOfGtinWithoutCurrentSync'
                                                                   tdStyle={{fontWeight: 'bold', fontSize: 'large'}}
                                                                   dataFormat={unsyncedFormatter}
                                                                   dataSort={true}>
                                                                   # Artikel ohne aktuelle <br/>  Bestandsmeldung
                                                                   </TableHeaderColumn>
                                                <TableHeaderColumn dataField='noOfUnsyncedGtin'
                                                                   tdStyle={{fontWeight: 'bold', fontSize: 'large'}}
                                                                   dataFormat={unsyncedFormatter} dataSort={true}>#
                                                    Artikel nicht synchr.</TableHeaderColumn>
                                                <TableHeaderColumn dataField='tableId'
                                                                   tdStyle={{fontWeight: 'bold', fontSize: 'large'}}
                                                                   dataFormat={csvButtonFormatter} dataSort={false}>CSV Download</TableHeaderColumn>
                                            </BootstrapTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        storeReports: state.dashboard.get('storeReports').toJS()
    };
}

const ConnectedDashboardManager = connect(mapStateToProps, {fetchStoreReports, showAllOverdueSince})(DashboardManager);

export default ConnectedDashboardManager;



// WEBPACK FOOTER //
// ./src/admin/dashboard/DashboardManager.js